import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $fillHeight?: boolean }>`
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.05);

    ${({ $fillHeight }) =>
        $fillHeight &&
        css`
            flex: 1;
        `}
`;

export const Toggle = styled.div<{ $expanded?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    gap: 10px;

    padding: 14px 16px;
    user-select: none;
`;

export const Label = styled.div`
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 100%;
    text-transform: uppercase;

    display: flex;
    align-items: center;
    gap: 5px;
`;

export const Count = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 18px;
    height: 18px;

    color: rgba(255, 255, 255, 0.5);
    font-size: 10px;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: -0.3px;

    border-radius: 100px;
    background: rgba(255, 255, 255, 0.1);
`;

export const Content = styled(motion.div)``;

export const ContentScroll = styled.div`
    overflow-y: auto;
    padding: 0px 16px 14px 16px;
`;

export const ToggleIcon = styled.div`
    width: 20px;
    height: 20px;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 30px;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;

    svg {
        width: 11px;
    }
`;
